import { render, staticRenderFns } from "./FormPhoneInput.vue?vue&type=template&id=3981e94a"
import script from "./FormPhoneInput.vue?vue&type=script&lang=js"
export * from "./FormPhoneInput.vue?vue&type=script&lang=js"
import style0 from "./FormPhoneInput.vue?vue&type=style&index=0&id=3981e94a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports